const PROMOTIONS = {
  app_development_cta: {
    promotion_id: 'app_development_cta',
    promotion_name: 'SplendApp mobile app development',
    creative_slot: 'global_app_development_cta'
  },
  app_development_popup: {
    promotion_id: 'app_development_popup',
    promotion_name: 'SplendApp mobile app development',
    creative_slot: 'timed_app_development_popup'
  },
  header_website_cta: {
    promotion_id: 'header_website_cta',
    promotion_name: 'Visit SplendApp website',
    creative_slot: 'global_header'
  },
  footer_website_cta: {
    promotion_id: 'footer_website_cta',
    promotion_name: 'Visit SplendApp website',
    creative_slot: 'global_footer'
  }
}

export function trackPromotionClick(gtag, promotionKey, parameters = {}) {
  if (!gtag || typeof gtag.event !== 'function' || !PROMOTIONS[promotionKey]) return false

  const promotion = PROMOTIONS[promotionKey]

  const safeParameters = Object.fromEntries(
    Object.entries(parameters).filter(([key, value]) =>
      ['language', 'popup_trigger', 'source_route'].includes(key) &&
      ['string', 'number', 'boolean'].includes(typeof value)
    )
  )

  gtag.event('select_promotion', {
    ...promotion,
    items: [{ ...promotion }],
    ...safeParameters,
    destination_hostname: 'splendapp.com'
  })
  return true
}
